import React from 'react';
import { useTheme } from 'styled-components';

export const RightArrowSvg = (props) => {
  const { width, height, color, onClick, double, circle } = props;

  const theme = useTheme();

  if (double) {
    return (
      <svg className="cursor-pointer" width={width ?? "9"} height={height ?? "9"} viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.5 0.839844L3.5 3.83984L0.5 6.83984" stroke={color ?? theme?.colour?.primary ?? "#1DBD6B"} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M3.9375 0.839844L6.9375 3.83984L3.9375 6.83984" stroke={color ?? theme?.colour?.primary ?? "#1DBD6B"} strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }
  if (circle) {
    return (
      <svg width={width ?? "62"} height={height ?? "62"} viewBox="0 0 62 62" fill={color ?? theme?.colour?.primary ?? "#1DBD6B"} xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M61.8337 30.9998C61.8337 48.0198 47.9895 61.8332 31.0003 61.8332L30.1377 61.8213C13.516 61.364 0.166992 47.7314 0.166992 30.9998C0.166992 14.0107 13.9803 0.166504 31.0003 0.166504C47.9895 0.166504 61.8337 14.0107 61.8337 30.9998ZM24.8953 18.6665C24.0012 19.5915 24.0012 21.0407 24.9262 21.9348L34.022 30.9998L24.9262 40.0648C24.0012 40.959 24.0012 42.439 24.8953 43.3332C25.8203 44.2582 27.2695 44.2582 28.1637 43.3332L38.9245 32.634C39.3562 32.2023 39.6028 31.6165 39.6028 30.9998C39.6028 30.3832 39.3562 29.7973 38.9245 29.3657L28.1637 18.6665C27.732 18.204 27.1462 17.9882 26.5603 17.9882C25.9437 17.9882 25.3578 18.204 24.8953 18.6665Z" />
      </svg>
    )
  }

  return (
    <svg className="cursor-pointer" onClick={onClick} width={width ?? "9"} height={height ?? "9"} viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.54581 1.36838L7.83203 4.6546L4.54581 7.94082" stroke={color ?? theme?.colour?.primary ?? "#1DBD6B"} strokeWidth="1.16185" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
